/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import error from"../base/error";import isArray from"./isArray";const first=function(r){if(!isArray(r))throw new error.Generic("ArrayFirstError","Type is not an array");return r[0]};export default first;